import { type BoxProps } from '@mantine/core'
import { type PropsWithChildren, useEffect, useState } from 'react'

import { BoxGoogleMaps, type BoxGoogleMapsMarkerInfo } from '@flecto/ui'

import { useFormContext } from './AddressForm'

export function AddressFormMap({ ...props }: PropsWithChildren<BoxProps>) {
  const form = useFormContext()
  const [markers, setMarkers] = useState<BoxGoogleMapsMarkerInfo[]>([])

  useEffect(() => {
    const { latitude, longitude } = form.values

    if (latitude && longitude) {
      setMarkers([
        {
          lat: latitude,
          lng: longitude,
          label: '',
          show: true,
        },
      ])
    } else {
      setMarkers([])
    }
  }, [form.values])

  return <BoxGoogleMaps {...props} markers={markers} />
}
